import {
  getOutcomeTeamCompetitorId,
  type MainMarket,
} from "@/utilities/sharedBettingUtilities";

import type {
  EventStatus,
  ToggleSelectionPayload,
} from "@/hooks/firestore/betting/types";
import type { ProcessedRacingCompetitor } from "@/hooks/firestore/betting/useRacingEvents";
import type {
  ProcessedOutcomes,
  ProcessedBettingCompetitor,
} from "@/hooks/firestore/betting/useEvent";

export type OutcomeCompetitors = Record<
  string,
  ProcessedBettingCompetitor | ProcessedRacingCompetitor
>;

export type OutcomeLayoutProps = {
  outcomes: ProcessedOutcomes;
  competitors: OutcomeCompetitors;
  eventId: string;
  // A market keeps reading Prematch past kick-off, so the tiles need the event
  // to work out whether they're live.
  eventStatus?: EventStatus;
  marketId?: string;
  oddsFormat?: string;
  selections: string[];
  toggleSelection: (pick: ToggleSelectionPayload) => void;
  className?: string;
  isSuspended?: boolean;
  isOutright?: boolean;
  status?: string;
  isLoading?: boolean;
  mainMarket?: MainMarket | null;
  liftTeamNames?: boolean;
  // attribute a render style groups by - read renderFields[renderFieldsKey]
  // for label/sort
  renderFieldsKey?: string;
};

export const getOutcomeCompetitor = (
  competitors: OutcomeCompetitors,
  outcome?: ProcessedOutcomes[string],
  mainMarket?: MainMarket | null,
) => {
  const competitorId = getOutcomeTeamCompetitorId(outcome, mainMarket);
  return (competitorId ? competitors?.[competitorId] : null) ?? null;
};
